define("@ember/legacy-built-in-components/templates/empty", ["exports", "@ember/template-factory"], function (_exports, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = _exports.default = (0, _templateFactory.createTemplateFactory)({
    "id": "J3hEX+8O",
    "block": "[[],[],false,[]]",
    "moduleName": "@ember/legacy-built-in-components/templates/empty.hbs",
    "isStrictMode": false
  });
});